import axios from "axios";
import { server } from "../api";

const IndoorPositioningEquipment = {
  GetEquipment: async (machineID) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/equipment`,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "獲取機具定位器失敗",
          data: [],
        }
      );
    }
  },

  CreateEquipment: async (machineID, payload) => {
    try {
      const response = await axios.post(
        `${server}indoor-positioning/${machineID}/equipment`,
        payload,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "新增機具定位器失敗",
        }
      );
    }
  },

  UpdateEquipment: async (equipmentId, payload) => {
    try {
      const response = await axios.put(
        `${server}indoor-positioning/equipment/${equipmentId}`,
        payload,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "更新機具定位器失敗",
        }
      );
    }
  },

  DeleteEquipment: async (equipmentId) => {
    try {
      const response = await axios.delete(
        `${server}indoor-positioning/equipment/${equipmentId}`,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "刪除機具定位器失敗",
        }
      );
    }
  },

  CreateTag: async (equipmentId, payload) => {
    try {
      const response = await axios.post(
        `${server}indoor-positioning/equipment/${equipmentId}/tags`,
        payload,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "新增機具標籤失敗",
        }
      );
    }
  },

  UpdateTag: async (tagId, payload) => {
    try {
      const response = await axios.put(
        `${server}indoor-positioning/equipment/tags/${tagId}`,
        payload,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "更新機具標籤失敗",
        }
      );
    }
  },

  DeleteTag: async (tagId) => {
    try {
      const response = await axios.delete(
        `${server}indoor-positioning/equipment/tags/${tagId}`,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "刪除機具標籤失敗",
        }
      );
    }
  },
};

export default IndoorPositioningEquipment;
